import { useMutation } from "@tanstack/react-query";
import merchantUserService from "..";
import { UpdateMerchantUserServicesCommand } from "@/models/club";

function useUpdateMerchantUserServices() {
  return useMutation({
    mutationFn: (command: UpdateMerchantUserServicesCommand) => {
      return merchantUserService.updateMerchantUserServices(command);
    },
  });
}

export default useUpdateMerchantUserServices;
